"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Cookies = require('js-cookie');

var _require = require('./config'),
    cookieMap = _require.cookieMap,
    cookieOptions = _require.cookieOptions,
    cookieOptInKeys = _require.cookieOptInKeys,
    defaultCookie = _require.defaultCookie,
    COOKIE_SEPARATOR = _require.COOKIE_SEPARATOR,
    COOKIE_VALUATOR = _require.COOKIE_VALUATOR;

var DOMAIN = cookieOptions.DOMAIN,
    EXPIRES = cookieOptions.EXPIRES,
    NAME = cookieOptions.NAME,
    PATH = cookieOptions.PATH,
    SAME_SITE = cookieOptions.SAME_SITE;

var stringToInt = function stringToInt(str) {
  var casted = str;

  if (!isNaN(casted)) {
    casted = Number(str);
  }

  return casted;
};

var EcosiaCookie = /*#__PURE__*/function () {
  function EcosiaCookie() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, EcosiaCookie);

    this.defaultCookie = _objectSpread({}, defaultCookie);
    this.cookie = this.createCookie(options.cookieString);
  } // Check for the existence of a cookie with a given name.


  _createClass(EcosiaCookie, [{
    key: "createCookie",
    // Create the internal cookie representation by parsing raw cookie and
    // merging it to default one
    value: function createCookie(rawCookie) {
      var cookie;

      if (rawCookie) {
        var parsed = EcosiaCookie.parse(rawCookie);
        cookie = Object.keys(parsed).reduce(function (pairs, key) {
          if (key in cookieMap || cookieOptInKeys.indexOf(key) !== -1) {
            pairs[key] = parsed[key]; // eslint-disable-line no-param-reassign
          }

          return pairs;
        }, {});
      } else {
        cookie = {
          ma: 0
        };
      }

      return _objectSpread(_objectSpread({}, this.defaultCookie), cookie);
    }
  }, {
    key: "mapAttributesWithCookie",
    value: function mapAttributesWithCookie() {
      var attributes = {};
      var cookie = this.cookie;
      Object.keys(cookie).forEach(function (key) {
        attributes[cookieMap[key]] = cookie[key];
      });
      return attributes;
    }
  }, {
    key: "setCookieValue",
    value: function setCookieValue(key, value) {
      // the key could be either a cookie key (like `cid`) or a matching user attribute (`clientId`)
      var foundEntry = Object.entries(cookieMap).find(function (entry) {
        return entry.includes(key);
      });

      if (!foundEntry) {
        // we don't recognise the key as a cookie key, or user attribute
        return false;
      }

      var _foundEntry = _slicedToArray(foundEntry, 1),
          cookieKey = _foundEntry[0];

      this.cookie[cookieKey] = value || this.defaultCookie[cookieKey];
      return EcosiaCookie.saveCookie(this.cookie);
    }
  }], [{
    key: "hasCookie",
    value: function hasCookie(name) {
      return !!(typeof document !== 'undefined' && Cookies.get(name));
    }
  }, {
    key: "stringify",
    value: function stringify() {
      var cookie = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return Object.keys(cookie).filter(function (key) {
        return cookie[key] !== null && cookie[key] !== undefined;
      }).map(function (key) {
        return "".concat(key).concat(COOKIE_VALUATOR).concat(cookie[key]);
      }).join(COOKIE_SEPARATOR);
    }
  }, {
    key: "parse",
    value: function parse() {
      var cookie = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return cookie.split(COOKIE_SEPARATOR).map(function (chunk) {
        return chunk.split(COOKIE_VALUATOR);
      }).reduce(function (pairs, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return _objectSpread(_objectSpread({}, pairs), {}, _defineProperty({}, key, stringToInt(value)));
      }, {});
    }
  }, {
    key: "saveCookie",
    value: function saveCookie(cookie) {
      var cookieValue = EcosiaCookie.stringify(cookie); // Set the front-end client cookie with js-cookie's set() method

      if (cookieValue.length > 0) {
        var cookieHandler = Cookies.withConverter({
          write: function write(value) {
            return value; // Do no perform ainy encoding on the cookie value.
          },
          read: function read(value) {
            return value;
          }
        });
        cookieHandler.set(NAME, cookieValue, {
          domain: DOMAIN,
          expires: EXPIRES,
          path: PATH,
          sameSite: SAME_SITE
        });

        if (cookieHandler.get(NAME) === cookieValue) {
          return true;
        }
      }

      return false;
    }
  }]);

  return EcosiaCookie;
}();

module.exports = EcosiaCookie;